import { Component, OnDestroy, Inject, OnInit, ViewChild } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { AolService } from '../../services/aol';
import {
  takeUntil,
  delay,
  map,
  tap,
  debounceTime,
  distinctUntilChanged,
} from 'rxjs/operators';
import { SharedValidators } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/admin/services';
import {
  OptionService,
  OptionTypeService,
} from 'src/modules/features/setting/services';
interface ICompanyInfoModalContext {
  data: any;
  title?: string;
  editData: any;
  isEdit: boolean;
}
@Component({
  selector: 'app-new-assessment-component-modal-modal',
  templateUrl: './new-assessment-component-modal.html',
  styleUrls: ['./new-assessment-component-modal.scss'],
})
export class NewAssessmentModalComponent implements OnInit, OnDestroy {
  @ViewChild('captchaRef') refCapt;
  private unsubscribe$: Subject<void> = new Subject<void>();
  companyDetail: any;
  success: any;

  public loginPending: boolean;
  public detailForm: FormGroup;
  public pending: boolean;
  public formSubmitAttempt = false;
  public bppDetail: any;
  public error: any;
  public countries: any;
  public states: any;
  public mode = 'date';
  public max = new Date();

  public companyEmailLoading = false;
  public usernameLoading = false;
  public emailLoading = false;

  usernameError = true;
  usernameServerError;

  emailError = true;
  emailServerError;

  companyEmailError = true;
  companyEmailServerError;

  companyType;
  ownershipType;

  companyTypeObj;
  ownershipTypeObj;
  state;
  country;

  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'ownership_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'foreign_company_providers',
      },
    ],
  };

  collapseCompanySection = false;
  foreignObj;
  selectedCountry = 'NG';
  selectedState = '19';
  oldDetails: any;
  userObject;
  organizationId: string;
  organization;
  organizationss;
  ownership;
  foreign = true;
  optionTypeId;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: '',
      },
      {
        field: 'optionName',
        op: 'cn',
        data: '',
      },
    ],
  };
  filter: AppFilter = new AppFilter();
  optionType;
  lookupTemplates;
  extraData;
  DataEdit;
  user;

  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<ICompanyInfoModalContext, void, void>,
    private http: HttpClient,
    private organizationSvc: OrganizationService,
    private optionTypeSvc: OptionTypeService,
    private AolService: AolService,
    private optionSvc: OptionService
  ) {
    this.optionTypeId = 'network_operator_license_type';
    this.searchFilter.rules[0].data = this.optionTypeId;
    this.extraData = this.modal.context.data;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.organizationId = window.localStorage.getItem('organizationId');
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.user = JSON.parse(window.localStorage.getItem('user'));
    // this.getOptionTypes();
    this.getPage(1);
    this.detailForm = this.fb.group({
      networkOperatorLicenseType: ['', [Validators.required]],
      grossRevenue: ['', [Validators.required]],
      interconnectCost: ['', [Validators.required]],
      licenseNumber: ['', [Validators.required]],
      roamingCost: ['', [Validators.required]],
      vasPayable: ['', [Validators.required]],
      netRevenue: [''],
      percentPayable: [''],
      organizationAolId: [this.extraData.organizationAol.organizationAolId],
      year: [this.extraData.organizationAol.year],
    });
  }
  getPage(page) {
    this.filter.page = page;
    this.filter.rows = 1000000;
    this.pending = true;
    this.optionSvc.getPublicOption({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.lookupTemplates = res.rows;
        const extra = this.extraData;
        const editDatas = this.modal.context.editData;
        this.DataEdit = extra.networkAssessments.find(
          (watcher) =>
            watcher.networkOperatorAssessmentId ===
            editDatas.networkOperatorAssessmentId
        );
        if (this.modal.context.isEdit) {
          const result = this.lookupTemplates.find(
            (watcher) =>
              watcher.optionName === this.DataEdit.networkOperatorLicenseType
          );
          const data = { ...this.DataEdit };
          data.networkOperatorLicenseType = result.optionId;
          this.detailForm.patchValue(data);
        }
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }
  getOptionType() {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'optionTypeId',
          op: 'eq',
          data: '',
        },
      ],
    };
    let filter = new AppFilter({ sidx: 'optionTypeId', rows: 10 });
    searchFilter.rules[0].data = this.optionTypeId;
    filter.filters = JSON.stringify(searchFilter);
    this.optionTypeSvc.getOptionTypes({ params: filter }).subscribe(
      (res: any) => {
        this.optionType = res.rows[0];
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }
  getStates() {
    this.organizationSvc.getStates({ filter: '' }).subscribe((res) => {
      this.states = res['rows'];
    });
  }

  cancel() {
    this.formSubmitAttempt = false;
    window.location.reload();
  }

  isFieldValid(field: string) {
    return (
      (!this.detailForm.get(field).valid &&
        this.detailForm.get(field).touched) ||
      (this.detailForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  ngOnInit() { }
  submit() {
    this.modal.context.isEdit ? this.update() : this.save();
  }
  update() {
    this.error = null;
    this.success = null;
    this.formSubmitAttempt = false;
    if (this.detailForm.valid && this.companyEmailError) {
      this.pending = true;
      this.detailForm.value.netRevenue =
        this.detailForm.value.grossRevenue -
        this.detailForm.value.interconnectCost -
        this.detailForm.value.roamingCost -
        this.detailForm.value.vasPayable;
      this.detailForm.value.percentPayable =
        0.025 * this.detailForm.value.netRevenue;
      console.log(this.detailForm.value, ' this.detailForm.value');
      this.AolService.editContractorNetworkAssessment({
        body: this.detailForm.value,
        networkOperatorAssessmentId: this.DataEdit.networkOperatorAssessmentId,
      }).subscribe(
        (res: any) => {
          this.pending = false;
          this.success = 'Network assessment successfully updated';
          setTimeout(() => {
            this.modal.approve();
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
    } else {
      this.formSubmitAttempt = true;
    }
  }
  removeObjectWithId(arr, number) {
    return arr.filter((obj) => obj.licenseNumber !== number);
  }
  save() {
    this.error = null;
    this.success = null;
    this.formSubmitAttempt = false;
    if (this.detailForm.valid && this.companyEmailError) {
      this.pending = true;
      this.detailForm.value.netRevenue =
        this.detailForm.value.grossRevenue -
        this.detailForm.value.interconnectCost -
        this.detailForm.value.roamingCost -
        this.detailForm.value.vasPayable;
      this.detailForm.value.percentPayable =
        0.025 * this.detailForm.value.netRevenue;
      this.AolService.createContractorNetworkAssessment({
        body: this.detailForm.value,
        organizationAolId: this.detailForm.value.organizationAolId,
      }).subscribe(
        (res: any) => {
          this.pending = false;
          this.success = 'Network assessment successfully created';
          setTimeout(() => {
            this.modal.approve();
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  ngOnDestroy() {
    // this.unsubscribe$.next();
    // this.unsubscribe$.complete();
  }

  getOptionTypes() {
    // this.optionError = false;
    // this.optionLoading = true;
    this.organizationSvc
      .getOptions({ filter: JSON.stringify(this.optionFilter) })
      .pipe(
        takeUntil(this.unsubscribe$),
        map((res: any) => res['rows']),
        map((res: any) => {
          const options = {
            ownershipType: [],
            companyType: [],
            errorOption: [],
            providerType: [],
          };
          res.forEach((option) => {
            // console.log(option)
            switch (option.optionType.optionTypeId) {
              case 'ownership_type':
                options.ownershipType.push(option);
                break;
              case 'actual_company_type':
                options.companyType.push(option);
                break;
              case 'foreign_company_providers':
                options.providerType.push(option);
                break;
              default:
                options.errorOption.push(option);
            }
          });
          return options;
        })
      )
      .subscribe(
        (res) => {
          // this.optionLoading = false;
          this.companyType = res.companyType;
          this.ownershipType = res.ownershipType;
          // this.bizProvider = res.providerType;
        },
        (error) => {
          // console.log(error)
          // this.optionError = true;
          // this.optionLoading = false;
        }
      );
  }
}
export class AssessmentModal extends ComponentModalConfig<
  ICompanyInfoModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    editData: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Small
  ) {
    super(NewAssessmentModalComponent, { title, data, editData, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
